import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';

export const ARVyer = initConst<IComponentsConfig>(() => ({}));
